import { useEffect, useRef, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowBack, Cancel, Save } from "@mui/icons-material";
import { AcceptPaymentMethodEnum } from "../../../../../enums/AcceptPaymentMethodEnum";
import PaymentSetupPageMainContainer, {
    PaymentSetupPageMainContainerHandle,
} from "../../../PaymentSetupComponents/PaymentSetupPageMainContainer";
import { SellerPaymentFormData } from "../../../../../pages/AddNewGigPage/PaymentSetupPage/PaymentSetupPage";
import GGButton from "../../../../CommonComponents/GGButton/GGButton";
import "./AddNewGigPaymentsPage.scss";

const AddNewGigPaymentsPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const paymentFormRef = useRef<PaymentSetupPageMainContainerHandle>(null);
    const [isScrolled, setIsScrolled] = useState(false);
    const { gigFormData, selectedCategoryId, selectedSubcategoryId, paymentFormData, hasExistingPayment } = location.state || {};
    const [savedFormData, setSavedFormData] = useState<SellerPaymentFormData>({
        selectedPaymentMode: AcceptPaymentMethodEnum.UPI,
        upiId: "",
        bankAccountDetails: {
            accountNumber: "",
            bankIFSC: "",
            holderName: "",
            bankName: "",
        },
        acknowledgementChecked: false,
    });

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (paymentFormData) {
            setSavedFormData(paymentFormData);
        }
    }, [paymentFormData]);

    useEffect(() => {
        const handleScroll = () => {
            const scrollContainer = document.querySelector('.dashboard-content-scrollable') as HTMLElement;
            if (scrollContainer) {
                const scrollPosition = scrollContainer.scrollTop;
                setIsScrolled(scrollPosition > 10);
            } else {
                const scrollPosition = window.scrollY || document.documentElement.scrollTop;
                setIsScrolled(scrollPosition > 10);
            }
        };

        const timeoutId = setTimeout(() => {
            const scrollContainer = document.querySelector('.dashboard-content-scrollable') as HTMLElement;
            if (scrollContainer) {
                scrollContainer.addEventListener('scroll', handleScroll);
                handleScroll();
            }
            window.addEventListener('scroll', handleScroll, true);
        }, 100);

        return () => {
            clearTimeout(timeoutId);
            const scrollContainer = document.querySelector('.dashboard-content-scrollable') as HTMLElement;
            if (scrollContainer) {
                scrollContainer.removeEventListener('scroll', handleScroll);
            }
            window.removeEventListener('scroll', handleScroll, true);
        };
    }, []);

    const handleBackPress = () => {
        navigate("/freelancer-dashboard/my-gigs/add-new-gig", {
            state: { gigFormData, selectedCategoryId, selectedSubcategoryId },
        });
    };

    const handleNextPress = () => {
        paymentFormRef.current?.submit();
    };

    const uponValidatedSubmission = (paymentFormData: SellerPaymentFormData) => {
        setSavedFormData(paymentFormData);
        navigate("/freelancer-dashboard/my-gigs/add-new-gig/undertaking", {
            state: {
                gigFormData,
                selectedCategoryId,
                selectedSubcategoryId,
                paymentFormData,
                hasExistingPayment,
            },
        });
    };

    return (
        <div className="new-gig-editing-page add-new-gig-step-page" >
            <div className={`gig-edit-header ${isScrolled ? 'scrolled' : ''}`}>
                <div className="header-left">
                    <Typography variant="h5" className="gig-title-header">
                        Step(2/3): Add Payment Method
                    </Typography>
                </div>
                <div className="header-right">
                    <div className="vertical-divider"></div>
                    <div className="header-controls">
                        <div className="header-action-buttons">
                            <Button
                                variant="outlined"
                                startIcon={<ArrowBack />}
                                onClick={handleBackPress}
                                className="cancel-btn"
                            >
                                Previous
                            </Button>
                            <GGButton
                                variant="contained"
                                color="success"
                                startIcon={<Save />}
                                onClick={handleNextPress}
                                className="save-btn"
                            >
                                Next
                            </GGButton>
                        </div>
                    </div>
                </div>
                <div className="mobile-header-layout add-new-gig-mobile">
                    <div className="mobile-action-buttons">
                        <Button
                            variant="outlined"
                            startIcon={<Cancel />}
                            onClick={handleBackPress}
                            className="cancel-btn"
                            size="small"
                        >
                            Previous
                        </Button>
                        <GGButton
                            variant="contained"
                            color="success"
                            startIcon={<Save />}
                            onClick={handleNextPress}
                            className="save-btn"
                            size="small"
                        >
                            Next
                        </GGButton>
                    </div>
                </div>
            </div>
            <Box className="payment-setup-page">
                <PaymentSetupPageMainContainer
                    ref={paymentFormRef}
                    withButtonPanel={false}
                    showSingleButton={false}
                    savedFormData={savedFormData}
                    uponValidatedSubmission={uponValidatedSubmission}
                />
            </Box>
        </div>
    );
};

export default AddNewGigPaymentsPage;